module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "row log-reg-form__list--check"
  }, [_c('label', {
    staticClass: "checkbox -checkbox-long"
  }, [_c('span', {
    staticClass: "checkbox__text -black-checkbox-text log-reg-form__checkbox-text text-justify"
  }, [_c('h4', [_vm._v("\n                        " + _vm._s(_vm.$t('I_ACCEPT')) + "\n                        "), _c('a', {
    staticClass: "log-reg-form__link",
    attrs: {
      "href": _vm.eSklepUrl + _vm.$t('LINK_TERMS'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('PRO_ACCOUNT_RODO_TERMS')))])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registryData.rulesAgreement),
      expression: "registryData.rulesAgreement"
    }],
    staticClass: "checkbox__check-input validate-checkbox",
    attrs: {
      "required": "",
      "type": "checkbox",
      "name": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.registryData.rulesAgreement) ? _vm._i(_vm.registryData.rulesAgreement, null) > -1 : (_vm.registryData.rulesAgreement)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.registryData.rulesAgreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registryData, "rulesAgreement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registryData, "rulesAgreement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registryData, "rulesAgreement", $$c)
        }
      }, _vm.toggleDisabled]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkbox__check"
  }, [_vm._v(_vm._s(_vm.$t('I_ACCEPT')))]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn-primary m-2 pa-2",
    attrs: {
      "disabled": _vm.btnDisabledToggle
    },
    on: {
      "click": function($event) {
        return _vm.$emit('agree')
      }
    }
  }, [_c('span', [_vm._v("Click Me")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-172ca5dc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/termsAgreement.vue
// module id = 1168
// module chunks = 0